import { createContext } from 'react';

const AssignmentContext = createContext({});

export default AssignmentContext;
